import { useCallback } from "react";
import dayjs from "../../../../../configs/dayjs";

export const useFormatConvTime = () => {
  const format = useCallback((value: string): string => {
    const date = dayjs(value);

    const now = dayjs();

    const time: string = date.format("h:mm A");

    return now.diff(date, "d") === 0 ? time : date.format("MMM D");
  }, []);

  return { format };
};
